import { render } from "./Red.vue?vue&type=template&id=3a868cec&scoped=true&ts=true"
import script from "./Red.vue?vue&type=script&lang=ts"
export * from "./Red.vue?vue&type=script&lang=ts"

import "./Red.vue?vue&type=style&index=0&id=3a868cec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a868cec"]])

export default __exports__